export enum OrderItemTypeCode {
  WordwareLunch = 'wordware_lunch',
  DestinyFine = 'destiny_fine',
  OtherFee = 'other_fee',
  SkywardFee = 'skyward_fee',
  EpaytrakCartFee = 'epaytrak_cart_fee',
  SkywardLunch = 'skyward_lunch',
  TuitionContract = 'tuition_contract',
  Activity = 'activity',
  Insurance = 'insurance',
  AffinetyActivityFee = 'affinety_activity_fee',
  PrimeroLunch = 'primero_lunch',
  TitanLunch = 'titan_lunch',
  EpaytrakCartItem = 'epaytrak_cart_item',
  TuitionLicense = 'tuition_license',
  Childcare = 'childcare',
  CreditAccountTransaction = 'credit_account_transaction',
  AssignedDeposit = 'assigned_deposit',
  AdditionalCharge = 'additional_charge',
  CorePowerschoolFee = 'core_powerschool_fee',
  MbaPowerschoolFee = 'mba_powerschool_fee',
  MbaCafeLunch = 'mba_cafe_lunch',
  IncidentIqFee = 'incident_iq_fee',
  ProcessingFee = 'processing_fee'
}

export enum OrderItemTypeDescription {
  WordwareLunch = 'Lunch',
  DestinyFine = 'Destiny Fine',
  OtherFee = 'Other Fee',
  SkywardFee = 'Skyward Fee',
  EpaytrakCartFee = 'ePayTrak Cart Fee',
  SkywardLunch = 'Skyward Lunch',
  TuitionContract = 'Tuition Contract',
  Activity = 'Activity',
  AffinetyActivityFee = 'Affinety Activity Fee',
  Insurance = 'Insurance',
  PrimeroLunch = 'Primero Edge Lunch',
  TitanLunch = 'Titan Lunch',
  EpaytrakCartItem = 'ePayTrak Cart Item',
  TuitionLicense = 'Tuition License Fee',
  Childcare = 'Childcare',
  CreditAccountTransaction = 'Credit Account Transaction',
  AssignedDeposit = 'Assigned Deposit',
  AdditionalCharge = 'Additional Charge',
  CorePowerschoolFee = 'Core Powerschool Fee',
  MbaPowerschoolFee = 'MBA Powerschool Fee',
  MbaCafeLunch = 'MBA Cafe Lunch',
  IncidentIqFee = 'Incident IQ Fee',
  ProcessingFee = 'Processing Fee'
}

export enum OrderItemType {
  WordwareLunch = 1,
  DestinyFine = 2,
  OtherFee = 3,
  SkywardFee = 4,
  EpaytrakCartFee = 5,
  SkywardLunch = 6,
  TuitionContract = 7,
  Activity = 8,
  Insurance = 9,
  AffinetyActivityFee = 10,
  PrimeroLunch = 11,
  TitanLunch = 12,
  EpaytrakCartItem = 13,
  TuitionLicense = 14,
  Childcare = 15,
  CreditAccountTransaction = 20,
  AssignedDeposit = 21,
  AdditionalCharge = 22,
  CorePowerschoolFee = 23,
  MbaPowerschoolFee = 24,
  MbaCafeLunch = 25,
  IncidentIqFee = 26,
  ProcessingFee = 100
}

/**
 * Order item type id -> wire code. Mirrors `OrderItemType::$type_codes` in
 * shared/Constant/OrderItemType.php; the backend rejects any fee_category that
 * is not in that map, so the two must stay in sync.
 */
export const OrderItemTypeCodeById: Record<OrderItemType, OrderItemTypeCode> = {
  [OrderItemType.WordwareLunch]: OrderItemTypeCode.WordwareLunch,
  [OrderItemType.DestinyFine]: OrderItemTypeCode.DestinyFine,
  [OrderItemType.OtherFee]: OrderItemTypeCode.OtherFee,
  [OrderItemType.SkywardFee]: OrderItemTypeCode.SkywardFee,
  [OrderItemType.EpaytrakCartFee]: OrderItemTypeCode.EpaytrakCartFee,
  [OrderItemType.SkywardLunch]: OrderItemTypeCode.SkywardLunch,
  [OrderItemType.TuitionContract]: OrderItemTypeCode.TuitionContract,
  [OrderItemType.Activity]: OrderItemTypeCode.Activity,
  [OrderItemType.Insurance]: OrderItemTypeCode.Insurance,
  [OrderItemType.AffinetyActivityFee]: OrderItemTypeCode.AffinetyActivityFee,
  [OrderItemType.PrimeroLunch]: OrderItemTypeCode.PrimeroLunch,
  [OrderItemType.TitanLunch]: OrderItemTypeCode.TitanLunch,
  [OrderItemType.EpaytrakCartItem]: OrderItemTypeCode.EpaytrakCartItem,
  [OrderItemType.TuitionLicense]: OrderItemTypeCode.TuitionLicense,
  [OrderItemType.Childcare]: OrderItemTypeCode.Childcare,
  [OrderItemType.CreditAccountTransaction]: OrderItemTypeCode.CreditAccountTransaction,
  [OrderItemType.AssignedDeposit]: OrderItemTypeCode.AssignedDeposit,
  [OrderItemType.AdditionalCharge]: OrderItemTypeCode.AdditionalCharge,
  [OrderItemType.CorePowerschoolFee]: OrderItemTypeCode.CorePowerschoolFee,
  [OrderItemType.MbaPowerschoolFee]: OrderItemTypeCode.MbaPowerschoolFee,
  [OrderItemType.MbaCafeLunch]: OrderItemTypeCode.MbaCafeLunch,
  [OrderItemType.IncidentIqFee]: OrderItemTypeCode.IncidentIqFee,
  [OrderItemType.ProcessingFee]: OrderItemTypeCode.ProcessingFee
}
